import { Component, OnInit } from '@angular/core';
import { ClientInitService } from '../shared/ClientInitService';
import { UrlResp } from '../shared/UrlResp';
import { AppInsightsService } from '../shared/AppInsights.Service';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.scss']
})
export class ClientComponent implements OnInit {
  data: UrlResp;
  error = false;
  message = '';
  constructor(public clientService: ClientInitService, private appInsightsService: AppInsightsService) { }

  ngOnInit() {
    console.log('loading client service');
    this.appInsightsService.logPageView("Client UI Page View");
    this.clientService.getClient().subscribe( res => {
      this.data = res;
      if (this.data) {
          if (this.data.status_code !== '200') {
            this.error = true;
            if (this.data.message) {
                this.message = this.data.message;
            } else {
                this.message = 'Session has expired please close browser and try again';
            }
          } else {
            console.log('url ' + this.data.url);
            window.location.href = window.location.origin + this.data.url;
          }
      }
    });
  }

}
